import { formatDate } from './format/date';

export interface TrustedDeviceRow {
  id: string;
  label: string | null;
  last_used_at: string | null;
  expires_at: string;
}

export interface TrustedDeviceManagerLabels {
  title: string;
  description: string;
  empty: string;
  revoke: string;
  lastUsed: string; // "Last used {{date}}"
  neverUsed: string;
  expires: string; // "Expires {{date}}"
}

export interface TrustedDeviceManagerProps {
  devices: TrustedDeviceRow[];
  labels: TrustedDeviceManagerLabels;
  onRevoke: (id: string) => void;
  locale: string;
}

const fill = (template: string, date: string): string => template.replace('{{date}}', date);

// Presentational trusted-device list. Actions supplied by the consumer; dates
// go through the shared formatter. No i18n runtime, no DOM globals
// (browser + Wails safe).
export const TrustedDeviceManager = ({ devices, labels, onRevoke, locale }: TrustedDeviceManagerProps) => (
  <div className="trusted-device-manager">
    <h3 className="title is-6">{labels.title}</h3>
    <p className="mb-3 is-size-7 has-text-grey">{labels.description}</p>

    {devices.length === 0 ? (
      <p className="mb-3">{labels.empty}</p>
    ) : (
      <ul className="mb-3">
        {devices.map((d) => (
          <li key={d.id} className="is-flex is-justify-content-space-between is-align-items-center mb-2">
            <span>
              <strong>{d.label}</strong>
              <br />
              <span className="is-size-7 has-text-grey">
                {d.last_used_at ? fill(labels.lastUsed, formatDate(d.last_used_at, locale)) : labels.neverUsed}
                {' · '}
                {fill(labels.expires, formatDate(d.expires_at, locale))}
              </span>
            </span>
            <button type="button" className="button is-small is-danger is-light" onClick={() => onRevoke(d.id)}>
              {labels.revoke}
            </button>
          </li>
        ))}
      </ul>
    )}
  </div>
);
